// Client-side upload caps, in bytes. Storage rules put no size cap on team
// solutions/extras writes, so these constants are the effective limit for
// guest media. downloadPhotosV2 streams the event zip, so raising these does
// not require more function memory.
export const MAX_IMAGE_FILE_SIZE = 300 * 1024 * 1024; // 300MB — headroom for iPhone ProRAW/DNG originals
export const MAX_VIDEO_FILE_SIZE = 300 * 1024 * 1024; // 300MB
